import { render } from "./SecretView.vue?vue&type=template&id=241a3932&scoped=true"
import script from "./SecretView.vue?vue&type=script&lang=js"
export * from "./SecretView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241a3932"]])

export default __exports__